const SKIN_BANNER_MIN_WIDTH = 1200;

const STYLE_ELEMENT_ID = 'banner-resizer-styles';

function getOrCreateStyleElement(): HTMLStyleElement {
  let styleElement = document.getElementById(STYLE_ELEMENT_ID) as HTMLStyleElement | null;

  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = STYLE_ELEMENT_ID;
    styleElement.textContent = `
      .banner-resizer-scaled {
        transform-origin: top center !important;
        transform: scale(var(--banner-scale, 1)) !important;
      }
    `;
    document.head.appendChild(styleElement);
  }
  return styleElement;
}

export function scaleBanner(container: HTMLElement, wrapper: HTMLElement): void {
  if (!container || !wrapper) return;

  const iframeContainer =
    container.querySelector<HTMLElement>('[id^="google_ads_iframe_"]') ||
    container.querySelector<HTMLElement>('[id^="div-gpt-ad-"]');
  if (!iframeContainer) return;

  const iframe = iframeContainer.querySelector('iframe');
  if (!iframe) return;

  const containerWidth = container.offsetWidth;
  const iframeWidth = iframe.offsetWidth || parseInt(iframe.getAttribute('width') || '0', 10);
  const iframeHeight = iframe.offsetHeight || parseInt(iframe.getAttribute('height') || '0', 10);

  if (iframeWidth === 0 || iframeHeight === 0) return;
  if (iframeWidth >= SKIN_BANNER_MIN_WIDTH) return;

  const scale = iframeWidth <= containerWidth ? 1 : containerWidth / iframeWidth;

  if (scale < 1) {
    const scaledHeight = Math.floor(iframeHeight * scale);

    wrapper.style.overflow = 'hidden';
    wrapper.style.height = `${scaledHeight}px`;

    getOrCreateStyleElement();

    iframeContainer.style.setProperty('--banner-scale', scale.toString());
    iframeContainer.classList.add('banner-resizer-scaled');
  } else {
    wrapper.style.overflow = '';
    wrapper.style.height = '';
    iframeContainer.style.removeProperty('--banner-scale');
    iframeContainer.classList.remove('banner-resizer-scaled');
  }
}
